import React from "react";
import NewSessionMobile from "../../mobileViews/NewSession/NewSession";

const NewSession = (props) => {
  return <NewSessionMobile />;
};

export default NewSession;
